import { FORTA_BLACK } from '../../utils/colors';

import type { IconProps } from './types';

const TPStatusIcon = (props: IconProps) => {
  const { color = FORTA_BLACK } = props;

  return (
    <svg
      data-testid="tpStatusIcon"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill={color} />
    </svg>
  );
};

export default TPStatusIcon;
